import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
// import components
import DataProcessingSection from './DataProcessing';

class HomeMainSection extends React.Component{
  
  render(){
    return(
      <div css={css`
        padding: 5px;
      `}>
        <DataProcessingSection 
          list={this.props.sideMenuItems[0]}/>
      </div>
    )
  }
}

export default HomeMainSection